import { useEffect, useState, type ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

interface PageLayoutProps {
  children: ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <SiteHeader />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />

      <button
        type="button"
        aria-label="回到顶部"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`fixed bottom-6 right-4 md:right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center transition-all duration-300 cursor-pointer hover:bg-primary-600 ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}